import avatars from '@cp/ds/src/assets/images/avatars.png';
import { Image } from '@cp/ds/src/components/image';
import React, { ComponentType } from 'react';
import { Stack } from '@cp/ds/src/components/stack';
import { Typography } from '@cp/ds/src/components/typography';
import { Box, BoxProps } from '@cp/ds/src/components/box';
import { styled } from '@cp/ds/src/theme';
import { useTheme } from '@cp/ds/src/hooks/useTheme';
import { ClientType } from '@common/model/client/clientType';
import { Button } from '@cp/ds/src/components/button';
import VectorHorizontal from 'src/assets/shapes/vectors/vectorHorizontal.svg';
import { usePrefilter } from 'src/features/clientSelection';
import { useAuth } from 'src/features/auth';
import { toAsset } from '@cp/shared/image';
import { useTrackEvent } from 'src/shared/tracking';
import { createEventFactory } from '@cp/shared/tracking';

const infoData = [
  {
    title: ' Положительных отзывов',
    text: '1000 отзывов оставили родители и специалисты за последний год. Из них 970 положительные.',
  },
  {
    title: ' — свобода на час',
    text: 'Няня поиграет с ребенком, погуляет, встретит со школы, поможет с домашними заданиями, чтобы вы спокойно позанимались своими делами',
  },
];

const ContentBox = styled(Box, { name: 'Specialists' })(({ theme }) => ({
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
  gap: 2,
})) as unknown as ComponentType<BoxProps>;

export const TrustedSpecialists = () => {
  const theme = useTheme();
  const prefilter = usePrefilter();
  const login = useAuth();
  const track = useTrackEvent();

  return (
    <Stack
      sx={{
        display: 'grid',
        gap: theme.spacing(2.5),
        gridTemplateColumns: '1fr',
        p: 2.5,
        mb: { xs: '20px', md: '48px' },
        backgroundColor: 'white',
        borderRadius: `${theme.borderRadius.extraLarge}px`,
        boxShadow: '0px 0px 8px rgba(49, 63, 79, 0.15)',
        position: 'relative',
        '@media (min-width: 930px)': {
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: 5,
          p: 5,
        },
      }}
    >
      <Box
        sx={{
          display: 'none',
          position: 'absolute',
          bottom: '-1px',
          left: 0,
          width: '12%',
          color: theme.palette['gray light'],
          transform: 'scaleY(-1)',
          '@media (min-width: 930px)': {
            display: 'block',
          },
        }}
      >
        <VectorHorizontal />
      </Box>
      <Stack sx={{ gap: '20px', justifyContent: 'flex-start', alignItems: 'center' }}>
        <Image
          alt={''}
          asset={toAsset(avatars)}
          sx={{
            width: '100%',
            height: 'auto',
            objectFit: 'contain',
          }}
        />
        <Button
          onClick={() => {
            track(createEventFactory({ subject: 'trusted-specialists', action: 'click', object: 'find-specialist' })());
            return prefilter({
              requiredQuestions: ['careerId'],
              predefinedValues: { clientType: ClientType.Employer },
            }).then((cs) => login(cs.unwrap()));
          }}
          size="small"
        >
          Найти помощника
        </Button>
      </Stack>
      {infoData.map((el, i) => (
        <ContentBox key={i}>
          <Typography component="span" variant="h2">
            {i === 0 ? (
              '👍🏻 97%'
            ) : (
              <>
                <Typography component="span" sx={{ color: theme.palette['brand pink'] }} variant="h2">
                  You
                </Typography>
                Help
              </>
            )}
            {el.title}
          </Typography>
          <Typography component="p">{el.text}</Typography>
        </ContentBox>
      ))}
    </Stack>
  );
};
